module.exports = __webpack_public_path__ + "static/media/covid3.2423747a.jpg";